export default __webpack_public_path__ + "static/Prueba-DISC_Mobile-desktop-cbb36f59c1b35e34c0966603be5580cc.png";